import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "../../lib/api";
import { ROLE_LABELS } from "../../lib/labels";

const NEW = "__new";

function FormInfo({ form }) {
  if (!form) return <div className="text-xs text-slate-400">Pas de fiche (ancienne demande)</div>;
  const rows = [["Tél.", form.phone], ["Société", form.company_name], ["TVA", form.vat_number], ["Adresse", form.address],
    ["ID chauffeur", form.employee_id], ["Employeur", form.employer], ["Message", form.message]].filter(([, v]) => v);
  return <div className="text-xs text-slate-600 space-y-0.5">{rows.map(([l, v]) => <div key={l}><b>{l} :</b> {v}</div>)}</div>;
}

function ApproveRow({ p, companies, drivers, roles, onDone }) {
  const form = p.form || {};
  const initRole = p.requested_role || "chauffeur";
  const [f, setF] = useState({ name: p.name, role: initRole, company_id: initRole === "soustraitant" && form.company_name ? NEW : "", driver_id: "" });
  const approve = async () => {
    const body = { name: f.name, role: f.role, create_company: f.company_id === NEW, create_driver: f.driver_id === NEW,
      company_id: f.company_id && f.company_id !== NEW ? f.company_id : null, driver_id: f.driver_id && f.driver_id !== NEW ? f.driver_id : null };
    try { await api.post(`/pending-accounts/${p.id}/approve`, body); toast.success(`Accès validé pour ${p.email}`); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  const reject = async () => {
    const reason = window.prompt("Motif du refus (facultatif, envoyé par e-mail) :", "");
    if (reason === null) return;
    try { await api.delete(`/pending-accounts/${p.id}`, { params: { reason } }); toast.success("Demande refusée, e-mail envoyé"); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  const needCompany = ["soustraitant", "chauffeur"].includes(f.role);
  return (
    <tr data-testid={`pending-${p.id}`}>
      <td><b>{p.email}</b><div className="text-xs text-slate-500">{fmtDateTime(p.submitted_at || p.created_at)}</div>
        {p.requested_role && <div className="text-xs font-semibold text-amber-700" data-testid={`pending-requested-${p.id}`}>Demande : {ROLE_LABELS[p.requested_role]}</div>}</td>
      <td><FormInfo form={p.form} /></td>
      <td><input className="tl-input !py-1" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid={`pending-name-${p.id}`} /></td>
      <td>
        <select className="tl-select !py-1" value={f.role} onChange={(e) => setF({ ...f, role: e.target.value, company_id: "", driver_id: "" })} data-testid={`pending-role-${p.id}`}>
          {roles.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </td>
      <td>
        {needCompany && (
          <select className="tl-select !py-1" value={f.company_id} onChange={(e) => setF({ ...f, company_id: e.target.value, driver_id: "" })} data-testid={`pending-company-${p.id}`}>
            <option value="">Société…</option>
            {f.role === "soustraitant" && form.company_name && <option value={NEW}>+ Créer « {form.company_name} »</option>}
            {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        )}
        {f.role === "chauffeur" && f.company_id && f.company_id !== NEW && (
          <select className="tl-select !py-1 mt-1" value={f.driver_id} onChange={(e) => setF({ ...f, driver_id: e.target.value })} data-testid={`pending-driver-${p.id}`}>
            <option value="">Chauffeur…</option>
            <option value={NEW}>+ Créer « {f.name}{form.employee_id ? ` (${form.employee_id})` : ""} »</option>
            {drivers.filter((d) => d.company_id === f.company_id).map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
        )}
      </td>
      <td className="whitespace-nowrap">
        <button className="tl-btn tl-btn-primary tl-btn-sm" onClick={approve} data-testid={`pending-approve-${p.id}`}>Valider</button>
        <button className="tl-btn tl-btn-ghost tl-btn-sm ml-1" onClick={reject} data-testid={`pending-reject-${p.id}`}>Refuser</button>
      </td>
    </tr>
  );
}

export function PendingAccounts({ isAdmin, onApproved }) {
  const [rows, setRows] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const load = () => api.get("/pending-accounts").then((r) => setRows(r.data));
  useEffect(() => {
    load();
    api.get("/companies").then((r) => setCompanies(r.data));
    api.get("/drivers").then((r) => setDrivers(r.data));
  }, []);
  if (!rows.length) return null;
  const roles = Object.entries(ROLE_LABELS).filter(([k]) => isAdmin || ["soustraitant", "chauffeur"].includes(k));
  return (
    <div className="tl-card mb-4 overflow-x-auto border-2 border-amber-500" data-testid="pending-accounts">
      <h3 className="font-bold uppercase mb-2">Demandes d'inscription à valider ({rows.length})</h3>
      <table className="tl-table text-sm">
        <thead><tr><th>E-mail</th><th>Fiche</th><th>Nom</th><th>Profil</th><th>Rattachement</th><th /></tr></thead>
        <tbody>{rows.map((p) => <ApproveRow key={p.id} p={p} companies={companies} drivers={drivers} roles={roles} onDone={() => { load(); onApproved(); }} />)}</tbody>
      </table>
    </div>
  );
}
